import React, { Fragment, useState, useEffect } from 'react';
import styled from 'styled-components';
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  TextField
} from '@mui/material';

const OPTIONS = [
  'Planning tip',
  'Training tip',
  'Implementation tip',
  'Measurement and reporting tip',
  'Donor relations tip',
  'Stakeholder management tip',
  'Other'
];

const LessonSelector = ({ value, onChange, questionId }) => {
  const [customText, setCustomText] = useState();

  useEffect(() => {
    if (value && OPTIONS.indexOf(value) === -1) {
      setCustomText(value);
    }
  }, [value]);

  const handleChange = (e) => {
    if (e.target.value !== 'Other') setCustomText();
    onChange(e.target.value);
  };

  const handleChangeText = (e) => {
    setCustomText(e.target.value);
    onChange(e.target.value);
  };

  const isOther = value!==undefined&&(value===''||value === 'Other'||OPTIONS.indexOf(value) === -1);

  return <Container>
    <RadioGroup aria-label="gender" name="gender1" value={isOther?'Other':value} onChange={handleChange}>
      { OPTIONS.map(opt => (
        <RadioLabel value={opt} label={opt}/>
      ))}
      {isOther&&<Input value={customText} onChange={handleChangeText}/>}
    </RadioGroup>
  </Container>;
};

const Container = styled.div`
  width: 100%;
`;
export const RadioLabel = styled(FormControlLabel).attrs(({ checked }) => ({
  control: <Radio {...{ checked }}/>
}))`
  transform: translateY(-2px);
  margin-bottom: 5px;
  padding-left: 6px;
  .MuiRadio-root {
    padding: 4px !important;
  }
`;
const Input = styled(TextField)`
  width: 260px;
  max-width: 100%;
  background-color: #ffffff !important;
  margin-left: 27px !important;
  margin-bottom: 25px !important;
`;

export default LessonSelector;
